'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaginationSize = exports.getBusinessConference = exports.getEventUri = exports.getPublishedDraftFromResponse = exports.getEntityFromResponse = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _hasMany = require('./hasMany');
var getEntityFromResponse = exports.getEntityFromResponse = function getEntityFromResponse(action, key) {
  var composerSettings = Object.keys(action.response.entities.composer_settings).map(function (k) {
    return action.response.entities.composer_settings[k];
  })[0];
  return composerSettings.site && composerSettings.site[key];
};
var getPublishedDraftFromResponse = exports.getPublishedDraftFromResponse = function getPublishedDraftFromResponse(action) {
  var composerSettings = Object.keys(action.response.entities.composer_settings).map(function (k) {
    return action.response.entities.composer_settings[k];
  })[0];
  var publishedDraft = true;
  if (typeof composerSettings.publishedDraft != 'undefined') publishedDraft = composerSettings.publishedDraft;
  return publishedDraft;
};
var getEventUri = exports.getEventUri = function getEventUri(state) {
  return Object.keys(state.site.entities.events).map(function (k) {
    return state.site.entities.events[k];
  })[0].eventUri;
};

// Currently this method get the first business conference in the event
var getBusinessConference = exports.getBusinessConference = function getBusinessConference(state) {
  if (!state || !state.site.entities.business_conferences) return null;
  return Object.keys(state.site.entities.business_conferences)[0];
};

// If there are more than one speakers block,, pagination might behave unpredictably
var getPaginationSize = exports.getPaginationSize = function getPaginationSize(defaultLimit, state, propertyName) {
  var allProperties = {};
  if (!!state.app && !!state.app.modifiedItems) {
    allProperties = _extends({}, state.properties, state.app.modifiedItems.properties);
  } else {
    allProperties = _extends({}, state.properties);
  }
  var sizes = (0, _hasMany.where)(allProperties, 'propertyName', propertyName);
  if (sizes.length > 0) {
    return sizes[0].value;
  }
  return defaultLimit;
};